import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoChevronDownSmall, LazySvgoChevronDown, LazySvgoNewTab, LazySvgoSocialsInstagram, LazySvgoSocialsTiktok, LazySvgoSocialsX, LazySvgoSocialsYoutube } from '#components'
const lazyGlobalComponents = [
  ["SvgoChevronDownSmall", LazySvgoChevronDownSmall],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoNewTab", LazySvgoNewTab],
["SvgoSocialsInstagram", LazySvgoSocialsInstagram],
["SvgoSocialsTiktok", LazySvgoSocialsTiktok],
["SvgoSocialsX", LazySvgoSocialsX],
["SvgoSocialsYoutube", LazySvgoSocialsYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
